import {
  fetchFeatureListSuccess,
  putFeatureSuccess,
  getFeatureDetailSuccess
} from "../action/action";
import {
  finishLoading,
  dispatchError,
  enableLoading
} from "common/Stores/service/service";
import { api } from "common/api/api";

export const fetchFeatureList = () => {
  const url = '/features';
  return dispatch => {
    dispatch(enableLoading());
    api
      // .get(`/logbuild/features`)
      .get(url)
      .then(res => {
        dispatch(fetchFeatureListSuccess(res.data));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const putFeature = (featureId, payload) => {
  const url = `/features/${featureId}`;
  return dispatch => {
    dispatch(enableLoading());
    api
      // .put(`/logbuild/features`, payload)
      .patch(url, payload)
      .then(res => {
        dispatch(putFeatureSuccess(res.data));
        dispatch(fetchFeatureList());
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const getFeatureDetail = featureId => {
  const url = `/features/${featureId}`;
  return dispatch => {
    dispatch(enableLoading());
    api
      // .get(`/logbuild/features/${params}`)
      .get(url)
      .then(res => {
        dispatch(getFeatureDetailSuccess(res.data));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};
